<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Gestione <b>Siti</b> </h2>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Siti</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->


  <section class="col-md-12">

    <div class="card">
      <div class="card-header primary">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">

        <dx-data-grid 
          [dataSource]="dataSource" 
          [showBorders]="true" 
          [focusedRowEnabled]="true" 
          [focusedRowIndex]="0"
          [columnAutoWidth]="true" 
          [columnHidingEnabled]="true" 
          [showColumnLines]="true" 
          [showRowLines]="true"
          [rowAlternationEnabled]="true" 
          (onRowUpdating)="onUpdating($event)" 
          (onExporting)="onExporting($event)">

          <dxo-export [enabled]="true"></dxo-export>
          <dxo-editing mode="row" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true">
            <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
          </dxo-editing>

          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
          <dxi-column dataField="id" [formItem]="{ visible: false }" [visible]="false" [allowEditing]="false">
          </dxi-column>
          <dxi-column dataField="descrizione">
          </dxi-column>
        </dx-data-grid>

      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>
</div>